import { FloatingFormItem } from '@/components/_common';
import { Checkbox, Col, Row, Typography } from 'antd';

export default function CategoryConfigurationFields() {
  return (
    <>
      <Typography.Title level={4}>Configuração de categoria</Typography.Title>

      <Row gutter={[12, 8]}>
        <Col span={24} md={12} hidden>
          <FloatingFormItem
            name="showCategoryInCustomerListing"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>
              Exibir categoria do cliente na listagem de clientes
            </Checkbox>
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="showCategoryInAccountReceivable"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>Exibir categoria do cliente no contas a receber</Checkbox>
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="showCategoryInDirectSale"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>Exibir categoria do cliente na venda direta</Checkbox>
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="showCategoryInInvoice"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>Exibir categoria do cliente na nota fiscal</Checkbox>
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12}>
          <FloatingFormItem
            name="showCategoryInWorkOrder"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox>Exibir categoria do cliente no orçamento</Checkbox>
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
}
